import React from 'react';
import { Paper, Title, Text, Button, Stack, Center, Group } from '@mantine/core';
import { IconBrandGoogle, IconWand } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';
import { useMantineTheme } from '@mantine/core';

const LoginPage: React.FC = () => {
  const { signInWithGoogle, loading, error } = useAuth();
  const theme = useMantineTheme();

  return (
    <Center style={{ minHeight: '100vh', padding: theme.spacing.md }}>
      <Paper 
        radius="lg" 
        p="xl" 
        withBorder 
        sx={{
          width: '100%',
          maxWidth: 500,
          border: `2px solid ${theme.colors.gray[2]}`,
          background: 'linear-gradient(to bottom right, #ffffff, #f8f9fa)',
        }}
      >
        <Stack spacing="xl" align="center">
          <Group spacing="xs">
            <IconWand size={32} color={theme.colors.indigo[6]} />
            <Title order={2} sx={{ color: theme.colors.indigo[9] }}>
              Welcome to Learning Genie!
            </Title>
          </Group>
          
          <Text align="center" size="lg" color="dimmed">
            Your personal AI-powered learning assistant. Sign in to start generating personalized course content.
          </Text>

          <Paper 
            withBorder 
            p="xl" 
            radius="md" 
            sx={{ 
              width: '100%',
              background: theme.colors.gray[0],
              borderColor: theme.colors.gray[3],
            }}
          >
            <Stack spacing="xl" align="center">
              <Stack spacing="xs" align="center">
                <Text weight={500} size="lg" color={theme.colors.gray[7]}>
                  Get Started
                </Text>
                <Text align="center" color="dimmed" size="sm">
                  Sign in with your Google account to create and manage your learning journey
                </Text>
              </Stack>

              {error && (
                <Text color="red" size="sm" align="center">
                  {error}
                </Text>
              )}

              <Button
                fullWidth
                size="lg"
                leftIcon={<IconBrandGoogle size={20} />}
                onClick={() => signInWithGoogle()}
                loading={loading}
                sx={(theme) => ({
                  background: `linear-gradient(135deg, ${theme.colors.indigo[6]}, ${theme.colors.indigo[8]})`,
                  '&:hover': {
                    background: `linear-gradient(135deg, ${theme.colors.indigo[7]}, ${theme.colors.indigo[9]})`,
                  },
                })}
              >
                Continue with Google
              </Button>
            </Stack>
          </Paper>

          <Text size="sm" color="dimmed" align="center" px="md">
            By signing in, you'll be able to generate personalized course content, track your progress, and save your learning materials.
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
};

export default LoginPage; 